/** @format */

// import {filter} from 'lodash';
import React, { useState, useEffect } from "react";
// material
import {
  Button,
  Card,
  Stack,
  Typography,
  CardContent,
  TextField,
  Radio,
} from "@mui/material";
// components
import Page from "../../components/Page";
//
import { useNavigate, useParams } from "react-router-dom";
import Iconify from "../../components/Iconify";

// import qs from "qs"
import { useLocation } from "react-router";
import { Row, Col } from "react-bootstrap";

// import MenuItem from "@mui/material/MenuItem";

import Select from "react-select";

import textFormatter from "../../utils/TextFormatter";

import bniLogo from "../../assets/bank/bni.png";
import mandiriLogo from "../../assets/bank/mandiri.png";
import bcaLogo from "../../assets/bank/bca.png";
import briLogo from "../../assets/bank/bri.png";
import swal from "../../reusables/CustomSwal";
import PhoneNumber from "../../dao/PhoneNumber";

// ----------------------------------------------------------------------

// ----------------------------------------------------------------------

export default function Broadcast(props) {
  const navigate = useNavigate();
  // const location = useLocation();

  // const queryParams = qs.parse(location.search, {ignoreQueryPrefix: true});

  const { state } = useLocation();

  const [amountPurchase, setAmountPurchase] = useState(
    state?.amountPurchase ? state.amountPurchase : 0
  );

  const [contactName, setContactName] = useState(
    state?.contactName ? state.contactName : ""
  );
  const [contactEmail, setContactEmail] = useState(
    state?.contactEmail ? state.contactEmail : ""
  );
  const [contactCompany, setContactCompany] = useState(
    state?.contactCompany ? state.contactCompany : ""
  );
  const [contactAddress, setContactAddress] = useState(
    state?.contactAddress ? state.contactAddress : ""
  );

  const [paymentMethod, setPaymentMethod] = useState(
    state?.paymentMethod ? state.paymentMethod : null
  ); //BNI, MANDIRI, BCA, BRI

  const [selectedPhoneNumber, setSelectedPhoneNumber] = useState(
    state?.phoneNumber ? state.phoneNumber : null
  );
  const [numberSelection, setNumberSelection] = useState([]);

  const { waba_id } = useParams();

  useEffect(() => {
    if (state) {
      setAmountPurchase(state.amountPurchase ? state.amountPurchase : 0);
      setContactName(state.contactName ? state.contactName : "");
      setContactEmail(state.contactEmail ? state.contactEmail : "");
      setContactCompany(state.contactCompany ? state.contactCompany : "");
      setContactAddress(state.contactAddress ? state.contactAddress : "");
      setPaymentMethod(state.paymentMethod ? state.paymentMethod : null);
      setSelectedPhoneNumber(state.phoneNumber ? state.phoneNumber : null);
    }
    getPhoneNumbers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getPhoneNumbers = async () => {
    try {
      //TODO : Fill with correct WABA ID
      let result = await PhoneNumber.getAll(waba_id);
      // console.log("res", result);
      let formattedNumberSelection = result.map((obj) => {
        return {
          label: `${obj.display_phone_number} (${obj.verified_name})`,
          value: obj.display_phone_number,
        };
      });

      setNumberSelection(formattedNumberSelection);
    } catch (e) {
      console.log("ERROR", e);
      await swal.fire({
        title: "Error",
        text: "An error has occurred. Please try again later.",
        icon: "error",
      });
    }
  };

  const getLogo = () => {
    if (paymentMethod === "BNI") {
      return bniLogo;
    }
    if (paymentMethod === "MANDIRI") {
      return mandiriLogo;
    }
    if (paymentMethod === "BCA") {
      return bcaLogo;
    }
    if (paymentMethod === "BRI") {
      return briLogo;
    }
  };

  return (
    <Page title="Purchase">
      {/*<div style={{width : "100%", background : "olive", height :2}}> </div>*/}
      <div style={{ width: "100%", margin: 0, padding: 30, height: "100%" }}>
        <Row>
          <Col md={12}>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
              }}
            >
              <div
                onClick={() => {
                  navigate("/credits");
                }}
                style={{
                  cursor: "pointer",
                }}
              >
                <Iconify
                  width={60}
                  height={60}
                  color={"#DBDBDB"}
                  icon="ion:arrow-back-circle"
                  sx={{ marginRight: 1 }}
                />
              </div>

              <Stack direction="column" justifyContent="center">
                <Typography variant="h4">Purchase</Typography>
              </Stack>
            </div>

            <Card style={{ marginTop: 10 }}>
              <CardContent>
                <div
                  style={{
                    weight: "bold",
                    color: "black",
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                  }}
                >
                  <h5 style={{ marginBottom: 0, paddingBottom: 0 }}>
                    Form Purhcase
                  </h5>
                </div>
                <div
                  style={{
                    height: 1,
                    width: "100%",
                    marginTop: 5,
                    marginBottom: 5,
                    backgroundColor: "lightgray",
                  }}
                ></div>

                <Row style={{ marginTop: 15, fontSize: "0.9em" }}>
                  <Col md={12}>
                    <Card style={{ marginTop: 10, marginBottom: 10 }}>
                      <CardContent>
                        <Row>
                          <Col md={12}>
                            <div
                              style={{ fontSize: "1.2em", marginBottom: 10 }}
                            >
                              Phone Number
                            </div>
                            <div style={{ width: 600 }}>
                              <Select
                                styles={{
                                  container: (base) => ({
                                    ...base,
                                    width: "100%",
                                    borderBottom: "0em solid rgb(55, 129, 187)",
                                  }),
                                  menuPortal: (base) => ({
                                    ...base,
                                    zIndex: 9999,
                                  }),
                                  menu: (provided) => ({
                                    ...provided,
                                    zIndex: "9999 !important",
                                  }),
                                }}
                                menuPortalTarget={document.querySelector(
                                  "body"
                                )}
                                onChange={(option) => {
                                  setSelectedPhoneNumber(option);
                                }}
                                value={selectedPhoneNumber}
                                options={numberSelection}
                              />
                            </div>
                          </Col>
                        </Row>
                      </CardContent>
                    </Card>
                  </Col>
                  <Col md={8}>
                    <Card>
                      <CardContent>
                        <Row>
                          <Col
                            style={{
                              borderRight: "1px solid lightgray",
                            }}
                            md={5}
                          >
                            <div
                              style={{
                                weight: "bold",
                                color: "black",
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                              }}
                            >
                              <div style={{ fontSize: "1.2em" }}>
                                Amount Purchase
                              </div>

                              {amountPurchase > 0 &&
                              amountPurchase <= 100000000 ? (
                                <Iconify
                                  width={25}
                                  height={25}
                                  color={"#bde321"}
                                  icon="mdi:tick-circle"
                                  sx={{ marginLeft: 1 }}
                                />
                              ) : null}
                            </div>
                            <TextField
                              inputProps={{ style: { fontSize: "0.8em" } }} // font size of input text
                              hiddenLabel={true}
                              fullWidth
                              value={amountPurchase}
                              onChange={(e) => {
                                if (!isNaN(parseInt(e.target.value))) {
                                  setAmountPurchase(parseInt(e.target.value));
                                }
                              }}
                              InputLabelProps={{ shrink: false }}
                              sx={{
                                "& legend": { display: "none" },
                                "& fieldset": { top: 0 },
                              }}
                            />
                            <div style={{ fontSize: "0.7em" }}>
                              Minimum is Rp100.000 and maximum purchase is
                              Rp100.000.000
                            </div>
                          </Col>
                          <Col md={7}>
                            <div style={{ fontSize: "1.2em" }}>
                              Total Purchase
                            </div>
                            <div
                              style={{
                                marginTop: 10,
                                display: "flex",
                                flexDirection: "row",
                              }}
                            >
                              <div
                                style={{
                                  fontSize: "0.9em",
                                  color: "grey",
                                  flex: 1,
                                }}
                              >
                                Credits
                              </div>
                              <div style={{ fontSize: "0.9em", color: "grey" }}>
                                <b>
                                  {textFormatter.moneyFormatter(amountPurchase)}
                                </b>
                              </div>
                            </div>
                            <div
                              style={{
                                marginTop: 5,
                                display: "flex",
                                flexDirection: "row",
                              }}
                            >
                              <div
                                style={{
                                  fontSize: "0.9em",
                                  color: "grey",
                                  flex: 1,
                                }}
                              >
                                Tax (11%)
                              </div>
                              <div style={{ fontSize: "0.9em", color: "grey" }}>
                                <b>
                                  {textFormatter.moneyFormatter(
                                    Math.round(amountPurchase * 0.11)
                                  )}
                                </b>
                              </div>
                            </div>
                            <div
                              style={{
                                height: 1,
                                width: "100%",
                                marginTop: 10,
                                marginBottom: 10,
                                backgroundColor: "lightgray",
                              }}
                            ></div>
                            <div
                              style={{
                                marginTop: 5,
                                display: "flex",
                                flexDirection: "row",
                              }}
                            >
                              <div style={{ fontSize: "0.9em", flex: 1 }}>
                                <b>Total Amount</b>
                              </div>
                              <div style={{ fontSize: "0.9em" }}>
                                <b>
                                  {textFormatter.moneyFormatter(
                                    Math.round(amountPurchase * 1.11)
                                  )}
                                </b>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </CardContent>
                    </Card>
                    <Row style={{ marginTop: 20 }}>
                      <Col md={8}>
                        <Card>
                          <CardContent>
                            <div
                              style={{
                                weight: "bold",
                                color: "black",
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                              }}
                            >
                              <div style={{ fontSize: "1.2em" }}>
                                Contact Information
                              </div>

                              {contactName &&
                                contactCompany &&
                                contactEmail &&
                                contactAddress && (
                                  <Iconify
                                    width={25}
                                    height={25}
                                    color={"#bde321"}
                                    icon="mdi:tick-circle"
                                    sx={{ marginLeft: 1 }}
                                  />
                                )}
                            </div>
                            <Row style={{ marginTop: 10 }}>
                              <Col md={6} style={{ marginBottom: 15 }}>
                                <TextField
                                  placeholder={"Name"}
                                  inputProps={{ style: { fontSize: "0.8em" } }} // font size of input text
                                  hiddenLabel={true}
                                  fullWidth
                                  value={contactName}
                                  onChange={(e) => {
                                    setContactName(e.target.value);
                                  }}
                                  InputLabelProps={{ shrink: false }}
                                  sx={{
                                    "& legend": { display: "none" },
                                    "& fieldset": { top: 0 },
                                  }}
                                />
                              </Col>
                              <Col md={6} style={{ marginBottom: 15 }}>
                                <TextField
                                  placeholder={"Company Name"}
                                  inputProps={{ style: { fontSize: "0.8em" } }} // font size of input text
                                  hiddenLabel={true}
                                  fullWidth
                                  value={contactCompany}
                                  onChange={(e) => {
                                    setContactCompany(e.target.value);
                                  }}
                                  InputLabelProps={{ shrink: false }}
                                  sx={{
                                    "& legend": { display: "none" },
                                    "& fieldset": { top: 0 },
                                  }}
                                />
                              </Col>
                              <Col md={6} style={{ marginBottom: 15 }}>
                                <TextField
                                  placeholder={"Email"}
                                  inputProps={{ style: { fontSize: "0.8em" } }} // font size of input text
                                  hiddenLabel={true}
                                  fullWidth
                                  value={contactEmail}
                                  onChange={(e) => {
                                    setContactEmail(e.target.value);
                                  }}
                                  InputLabelProps={{ shrink: false }}
                                  sx={{
                                    "& legend": { display: "none" },
                                    "& fieldset": { top: 0 },
                                  }}
                                />
                              </Col>
                              <Col md={6} style={{ marginBottom: 15 }}>
                                <TextField
                                  placeholder={"Address"}
                                  inputProps={{ style: { fontSize: "0.8em" } }} // font size of input text
                                  hiddenLabel={true}
                                  fullWidth
                                  value={contactAddress}
                                  onChange={(e) => {
                                    setContactAddress(e.target.value);
                                  }}
                                  InputLabelProps={{ shrink: false }}
                                  sx={{
                                    "& legend": { display: "none" },
                                    "& fieldset": { top: 0 },
                                  }}
                                />
                              </Col>
                            </Row>
                          </CardContent>
                        </Card>
                      </Col>
                      <Col md={4}>
                        <Card style={{ height: "100%" }}>
                          <CardContent
                            style={{
                              color: "grey",
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "center",
                              height: "100%",
                              fontSize: "0.9em",
                            }}
                          >
                            <div style={{ fontSize: "1.2em" }}>
                              History Contact
                            </div>
                            <br />
                            <b>Zeman Mustohid</b>
                            <div>zaemanmustohid21@gmail.com</div>
                            <div>PT. Infomedia Nusantara</div>
                            <div>Jl. Fatmawati Jakarta Selatan</div>
                            <div
                              style={{
                                marginTop: 10,
                                display: "flex",
                                justifyContent: "flex-end",
                              }}
                            >
                              <Button
                                onClick={() => {
                                  setContactName("Zeman Mustohid");
                                  setContactCompany("PT. Infomedia Nusantara");
                                  setContactEmail("zaemanmustohid21@gmail.com");
                                  setContactAddress(
                                    "Jl. Fatmawati Jakarta Selatan"
                                  );
                                }}
                                style={{
                                  fontSize: "0.8em",
                                  backgroundColor: "#6160dc",
                                  borderColor: "#6160dc",
                                  boxShadow: "none",
                                }}
                                variant={"contained"}
                              >
                                Apply
                              </Button>
                            </div>
                          </CardContent>
                        </Card>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={12}>
                        <Card style={{ marginTop: 10 }}>
                          <CardContent>
                            <div
                              style={{
                                weight: "bold",
                                color: "black",
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                              }}
                            >
                              <div style={{ fontSize: "1.2em" }}>
                                Select Payment Method
                              </div>
                              {paymentMethod && (
                                <Iconify
                                  width={25}
                                  height={25}
                                  color={"#bde321"}
                                  icon="mdi:tick-circle"
                                  sx={{ marginLeft: 1 }}
                                />
                              )}
                            </div>
                            <div
                              style={{ fontSize: "0.8em", color: "#8E8EA1" }}
                            >
                              Virtual Account - Automatic verification without
                              uploading the proof of payment.
                            </div>
                            <Row>
                              <Col
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                  alignItems: "center",
                                  paddingRight: 50,
                                }}
                                md={3}
                              >
                                <div>
                                  <Radio
                                    sx={{
                                      "&.Mui-checked": {
                                        color: "#00a389",
                                      },
                                    }}
                                    onClick={() => {
                                      setPaymentMethod("BNI");
                                    }}
                                    checked={paymentMethod === "BNI"}
                                  />
                                </div>
                                <img
                                  style={{
                                    objectFit: "contain",
                                    width: "100%",
                                  }}
                                  src={bniLogo}
                                  alt="bnilogo"
                                />
                              </Col>
                              <Col
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                  alignItems: "center",
                                }}
                                md={3}
                              >
                                <div>
                                  <Radio
                                    sx={{
                                      "&.Mui-checked": {
                                        color: "#00a389",
                                      },
                                    }}
                                    onClick={() => {
                                      setPaymentMethod("MANDIRI");
                                    }}
                                    checked={paymentMethod === "MANDIRI"}
                                  />
                                </div>
                                <img
                                  style={{ objectFit: "contain" }}
                                  src={mandiriLogo}
                                  alt={"mandirilogo"}
                                />
                              </Col>
                              <Col
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                  alignItems: "center",
                                }}
                                md={3}
                              >
                                <div>
                                  <Radio
                                    sx={{
                                      "&.Mui-checked": {
                                        color: "#00a389",
                                      },
                                    }}
                                    onClick={() => {
                                      setPaymentMethod("BCA");
                                    }}
                                    checked={paymentMethod === "BCA"}
                                  />
                                </div>
                                <img
                                  style={{ objectFit: "contain" }}
                                  src={bcaLogo}
                                  alt="bcalogo"
                                />
                              </Col>
                              <Col
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                  alignItems: "center",
                                }}
                                md={3}
                              >
                                <div>
                                  <Radio
                                    sx={{
                                      "&.Mui-checked": {
                                        color: "#00a389",
                                      },
                                    }}
                                    onClick={() => {
                                      setPaymentMethod("BRI");
                                    }}
                                    checked={paymentMethod === "BRI"}
                                  />
                                </div>
                                <img
                                  style={{ objectFit: "contain" }}
                                  src={briLogo}
                                  alt="brilogo"
                                />
                              </Col>
                            </Row>
                          </CardContent>
                        </Card>
                      </Col>
                    </Row>
                  </Col>
                  <Col md={4}>
                    <Card style={{ height: "100%" }}>
                      <CardContent
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          height: "100%",
                        }}
                      >
                        <div style={{ flex: 1 }}>
                          <h5 style={{ marginBottom: 0, paddingBottom: 0 }}>
                            Summary Purchase
                          </h5>
                          <div
                            style={{
                              marginTop: 10,
                              display: "flex",
                              flexDirection: "row",
                            }}
                          >
                            <div
                              style={{
                                fontSize: "0.9em",
                                color: "grey",
                                flex: 1,
                              }}
                            >
                              Credits
                            </div>
                            <div style={{ fontSize: "0.9em", color: "grey" }}>
                              <b>
                                {textFormatter.moneyFormatter(amountPurchase)}
                              </b>
                            </div>
                          </div>
                          <div
                            style={{
                              marginTop: 5,
                              display: "flex",
                              flexDirection: "row",
                            }}
                          >
                            <div
                              style={{
                                fontSize: "0.9em",
                                color: "grey",
                                flex: 1,
                              }}
                            >
                              Tax (11%)
                            </div>
                            <div style={{ fontSize: "0.9em", color: "grey" }}>
                              <b>
                                {textFormatter.moneyFormatter(
                                  Math.round(amountPurchase * 0.11)
                                )}
                              </b>
                            </div>
                          </div>
                          <div
                            style={{
                              height: 1,
                              width: "100%",
                              marginTop: 10,
                              marginBottom: 10,
                              backgroundColor: "lightgray",
                            }}
                          ></div>
                          <div
                            style={{
                              marginTop: 5,
                              display: "flex",
                              flexDirection: "row",
                            }}
                          >
                            <div style={{ fontSize: "0.9em", flex: 1 }}>
                              <b>Total Amount</b>
                            </div>
                            <div style={{ fontSize: "0.9em" }}>
                              <b>
                                {textFormatter.moneyFormatter(
                                  Math.round(amountPurchase * 1.11)
                                )}
                              </b>
                            </div>
                          </div>

                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              color: "grey",
                              alignItems: "flex-start",
                            }}
                          >
                            {contactName &&
                              contactCompany &&
                              contactEmail &&
                              contactAddress && (
                                <>
                                  <b
                                    style={{
                                      fontSize: "1.1em",
                                      marginTop: 30,
                                      marginBottom: 10,
                                    }}
                                  >
                                    Contact Information
                                  </b>

                                  <b>Zeman Mustohid</b>
                                  <div>zaemanmustohid21@gmail.com</div>
                                  <div>PT. Infomedia Nusantara</div>
                                  <div>Jl. Fatmawati Jakarta Selatan</div>
                                </>
                              )}

                            {paymentMethod && (
                              <>
                                <b style={{ fontSize: "1.1em", marginTop: 30 }}>
                                  Payment Method
                                </b>
                                <div style={{ fontSize: "0.85em" }}>
                                  Virtual Account
                                </div>
                                <img
                                  style={{ objectFit: "contain", height: 50 }}
                                  src={getLogo()}
                                  alt="logo"
                                />
                              </>
                            )}
                          </div>
                        </div>

                        <Button
                          style={{
                            backgroundColor: "#6160dc",
                            borderColor: "#6160dc",
                            boxShadow: "none",
                          }}
                          onClick={() => {
                            if (!selectedPhoneNumber) {
                              return swal.fire({
                                title: "Error",
                                text: "Please select Phone Number",
                                icon: "error",
                              });
                            }
                            if (amountPurchase < 100000) {
                              return swal.fire({
                                title: "Error",
                                text: "Minimum purchase is Rp100.000",
                                icon: "error",
                              });
                            }
                            if (amountPurchase > 100000000) {
                              return swal.fire({
                                title: "Error",
                                text: "Maximum purchase is Rp100.000.000",
                                icon: "error",
                              });
                            }
                            if (
                              !(
                                contactName &&
                                contactCompany &&
                                contactEmail &&
                                contactAddress
                              )
                            ) {
                              return swal.fire({
                                title: "Error",
                                text: "Please fill in contact information",
                                icon: "error",
                              });
                            }
                            if (!paymentMethod) {
                              return swal.fire({
                                title: "Error",
                                text: "Please fill in a payment method",
                                icon: "error",
                              });
                            }
                            navigate("/purchase/review", {
                              state: {
                                amountPurchase,
                                contactName,
                                contactEmail,
                                contactCompany,
                                contactAddress,
                                paymentMethod,
                                phoneNumber: selectedPhoneNumber,
                                wabaId: waba_id,
                              },
                            });
                          }}
                          variant={"contained"}
                        >
                          Lanjutkan Pembayaran
                        </Button>
                      </CardContent>
                    </Card>
                  </Col>
                </Row>
              </CardContent>
            </Card>
          </Col>
        </Row>
      </div>
    </Page>
  );
}
